export default "__VITE_ASSET__Q3VV8$YA__"